<template>
    <v-layout row wrap justify-center>
        <v-flex xs12 py-3 text-xs-center white--text>
            <v-dialog v-model="dialogOpen"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition">
                <div slot="activator">Credits And Additional Info</div>
                <v-card>
                    <v-toolbar>
                        <v-toolbar-title>Credits And Additional Info</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon @click.native="dialogOpen = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text class="ma-3">
                        <h2 class="headline">Credits</h2>
                        <p class="body-1">
                            A weekend project by Damian <a href="mailto:dm21cris@alum.siena.edu" style="color: white">
                            Email
                        </a>
                        </p>
                        <p class="title">Thanks to</p>
                        <p class="body-1">
                            <a href="https://github.com/reswitched/fusee-launcher" style="color: white">
                                ReSwitched for the discovery of the Fusée Gelée exploit.
                            </a>
                        </p>
                        <p class="body-1">
                            <a href="https://sx.xecuter.com" style="color: white">
                                Team Xecuter for SX OS and SX Loader.
                            </a>
                        </p>
                        <p class="body-1">
                            <a href="https://github.com/CTCaer/hekate" style="color: white">
                                CTCaer for the Hekate mod.
                            </a>
                        </p>
                        <p class="body-1">
                            <a href="https://github.com/atlas44/web-fusee-launcher" style="color: white">
                                Atlas44 for the original port of the Fusée Gelée exploit to JavaScript which was
                                heavily referenced.
                            </a>
                        </p>
                        <h2 class="title">Additional Info</h2>
                        <p class="body-1">
                            Disclaimer: I am not responsible if use of this tool causes Nintendo to issue a ban
                            from online services (which it probably will) or causes any damages to hardware.
                        </p>
                        <p class="body-1">
                            On Linux, you might get an access denied error! If you do, you can try creating a file at
                            <var>/etc/udev/rules.d/50-switch.rules</var> With the following contents: <br/>
                            <code>SUBSYSTEM=="usb", ATTR{idVendor}=="0955", MODE="0664", GROUP="plugdev"</code>.
                        </p>
                        <p class="body-1">
                            This does NOT work on Windows due to a limitation in the Chrome implementation of WebUSB (and probably other reasons!).
                        </p>
                        <p>
                            This has been tested and appears to work on the Chrome web browser running on
                            Linux, OSX, Android and Chromebooks. Your mileage may vary.
                        </p>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>
<script>
export default {
  data() {
    return {
      dialogOpen: false
    };
  }
};
</script>
